import type { CSSProperties, ReactNode } from 'react';

interface CardProps {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function Card({ title, action, children, className = '', style }: CardProps) {
  return (
    <div className={`card ${className}`.trim()} style={style}>
      {(title || action) && (
        <div className="card-hdr">
          {title && <div className="card-title title-sm">{title}</div>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
